import { render, staticRenderFns } from "./CreateBase.vue?vue&type=template&id=07ef41f6&"
import script from "./CreateBase.vue?vue&type=script&lang=js&"
export * from "./CreateBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports